<template>
  <div class="content">
    <div class="row">
      <div class="col-xs-12 text-center">
        <div class="alert alert-danger">
          <slot></slot>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'error-display',
  };
</script>



// WEBPACK FOOTER //
// ErrorDisplay.vue?50600492